import { HookWebSocket } from 'Hook'
import { TypeNav, TypeNavHttpControl, TypeNavSocketPayload, TypeWebSocketControl } from 'Type'

const HookNavSocket = <ID,>(navControl? :TypeNavHttpControl<any>) :TypeWebSocketControl<TypeNavSocketPayload<ID>> => {
    const nav :TypeNav<any> | undefined = navControl?.res?.data
    const path :string | undefined = (nav && nav.control.connectable) ? nav.path : undefined
    return HookWebSocket({path})
}

export default HookNavSocket